import type { Translations } from '@change-corgi/core/i18n';

export const getTranslationsOverrides = (_locale: string): Translations | undefined => undefined;
